<script setup lang="ts">
import type { StaticBodyProps } from '~/types/appTypes'

const props = withDefaults(defineProps<StaticBodyProps>(), {})

const publicRuntimeConfig = useRuntimeConfig().public
const app = useNuxtApp()
const appConfig = useAppConfig()
const route = useRoute()

const refData = reactive({
  isGSearch: false,
  isUpdateDom: false,
  modelGceSearch: '',
})

const staticBody = ref(null)

const setBody = () => {
  refData.isUpdateDom = true
  const elDiv = staticBody.value
  const colStyles = elDiv.getElementsByTagName('style')
  if (colStyles) {
    for (let i = 0; i < colStyles.length; i++) {
      let style = colStyles[i].innerHTML
      style = style.split(/\n/)
      if (style) {
        for (let s = 0; s < style.length; s++) {
          style[s].trim()
          const result = style[s].match(/^[.#]/)
          if (result) {
            style[s] = '#staticBody ' + style[s]
          }
        }
      }
      style = style.join('\n')
      colStyles[i].innerHTML = style
    }
  }
}

const onKeyEnter = (event) => {
  if (event.keyCode !== 13) {
    return
  }
  onClickSearch()
}

const onClickSearch = () => {
  if (!refData.modelGceSearch) {
    return
  }
  const query = appConfig.app.googleCustomSearch
  window.window.open(publicRuntimeConfig.baseOrigin + '/site-search/?cx=' + query.cx + '&ie=' + query.ie + '&q=' + refData.modelGceSearch)
}

if (route.params.slug === '567') {
  app.isGSearch = true
}

onMounted(() => {
  nextTick(() => {
    setBody()
  })
})
</script>

<template>
  <div id="staticBody">
    <div
      v-if="item"
      v-bind:class="(item.is_old === 1) ? 'p-staticBodyOld l-blank-icon-none' : 'p-staticBodyNew l-blank-icon-none'"
    >
      <div
        ref="staticBody"
        v-html="app.$getArticleBody(item)"
      />
    </div>
    <div
      v-if="refData.isGSearch"
      class="c-gSearch"
    >
      <div class="c-gSearch_title">
        ミュージアム等の情報検索はこちら（試験中でも検索できます）
      </div>
      <div class="c-gSearch_form">
        <div class="c-gSearch_input">
          <v-text-field
            v-model="refData.modelGceSearch"
            name="q"
            variant="outlined"
            density="compact"
            hide-details
            placeholder="Google カスタム検索（サイト内検索）"
            class="l-container_form_inputBlock_input IMCustomTextFieldMenu"
            v-on:keyup.enter="onKeyEnter"
          />
        </div>
        <div class="c-gSearch_btn">
          <button
            class="c-gSearch_btn_confirmButton"
            type="button"
            v-bind:disabled="!refData.modelGceSearch"
            v-on:click="onClickSearch"
          >
            <i class="c-gSearch_btn_confirmButton_icon" />
            探す
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang = "scss" scoped>
$path-image: "//www.museum.or.jp/uploads/imdb/file/xoops/";

/* stylelint-disable */
.p-staticBodyNew {
  // transform: rotate(0.03deg);
  // font-family: var(--g_font_family_MPuls);
  font-family: var(--g_font_family_NotoSansCJKjp);
  font-size: 16px;
  line-height: 1.8;
}

.p-staticBodyOld {
  width: 660px;
  margin: 0 0 50px 0;
  padding: 0;
  background-color: white;
  color: #333;
  font-size: 13px;
  line-height: 1.4;

  .sect_yuk {
    width: 600px;
    padding-left: 10px;
  }

  .sect_yuk * {
    margin: 0;
    padding: 0;
  }

  .sect_yuk .wrap_formbox {
  }

  .sect_yuk table.formbox {
    border-top: 1px solid #af8954;
    border-right: 1px solid #af8954;
  }

  .sect_yuk table.formbox th,
  .sect_yuk table.formbox td {
    padding: 8px;
    text-align: left;
    vertical-align: top;
  }

  .sect_yuk table.formbox th {
    width: 140px;
    border-bottom: 1px solid #af8954;
    border-left: 1px solid #af8954;
    background-color: #f3eee6;
  }

  .sect_yuk table.formbox th span {
    color: #ff2700;
  }

  .sect_yuk table.formbox td {
    border-bottom: 1px solid #af8954;
    border-left: 1px solid #af8954;
  }

  .sect_yuk table.formbox td .inp_full {
    width: 100%;
  }

  .sect_yuk table.formbox td .inp_half {
    width: 250px;
  }

  .sect_yuk table.formbox td .inp_mini {
    width: 8em;
  }

  .sect_yuk table.formbox td option {
    padding-right: 10px;
  }

  .sect_yuk table.formbox th.mds {
    width: auto;
    background-color: #af8954;
  }

  .sect_yuk table.formbox td.btn {
    width: auto;
    text-align: center;
  }

  th {
    color: #cfcfcf;
  }
}

:deep(.p-staticBodyOld) {
  div,
  span,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a,
  img,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  strong,
  sub,
  sup,
  i,
  small,
  address,
  time,
  fieldset,
  form,
  label,
  legend,
  hr,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  header,
  footer,
  nav,
  section,
  article,
  aside,
  figure,
  figcaption,
  canvas,
  audio,
  video {
    margin: initial;
    padding: initial;
    border: initial;
    font-style: initial;
    font-weight: initial;
    vertical-align: initial;
  }

  article,
  aside,
  figure,
  figcaption,
  footer,
  header,
  nav,
  section {
    display: initial;
  }

  *,
  *::before,
  *::after {
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -ms-box-sizing: content-box;
    box-sizing: content-box;
  }

  p {
    margin: 1em 0;
  }

  ul,
  ol,
  li {
    // list-style: initial;
    list-style: none;
  }

  input,
  textarea,
  button {
    margin: initial;
    padding: initial;
  }

  input[type="submit"],
  input[type="button"],
  button {
    cursor: initial;
  }

  img {
    max-width: 100%;
    height: initial;
    vertical-align: initial;

    &[height="1"] {
      // spacer
      height: 1px;
    }
  }

  .clearfix::after {
    content: "";
    display: initial;
    clear: initial;
  }

  a {
    text-decoration: initial;
  }

  strong,
  b {
    font-weight: bold;
  }

  h2 {
    margin: 0.5em 0;
    font-weight: bold;
  }

  table {
    border-spacing: 2px;
    // border: 1px solid rgb(214, 214, 214);
    font-size: inherit;

    &[border="0"] {
      border-width: 0;

      th,
      td {
        border-width: 0;
      }
    }

    &[border="1"] {
      border: 1px solid rgb(214, 214, 214);

      th,
      td {
        border: 1px solid rgb(214, 214, 214);
      }
    }
  }

  th,
  td {
    // border: 1px solid rgb(214, 214, 214);
  }

  div .url {
    word-wrap: break-word; /* IE 5+ */
    white-space: pre; /* CSS 2.0 */
    white-space: pre-wrap; /* CSS 2.1 */
    white-space: pre-line; /* CSS 3.0 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: -moz-pre-wrap; /* Mozilla */
    white-space: -hp-pre-wrap; /* HP Printers */
  }

  td {
    line-height: 150%;
  }

  img {
    border-style: none;
  }

  a img {
    border-style: none;
  }

  sup {
    vertical-align: top;
  }

  td .topSub {
    padding-left: 10px;
  }

  hr {
    height: 1px;
    margin: 7px 0;
    border: none;
    border-top: 1px #cfcfcf solid;
  }

  .notification {
    border: none;
  }

  #im_body ul {
    padding-left: 20px;
    list-style-image: url(#{$path-image}info-button.gif);
  }

  #im_body li {
    padding-bottom: 4px;
    padding-left: 0;
    background-image: none;
  }

  div .shadow {
    height: 20px;
    background-image: url(#{$path-image}top-shadow.png);
    background-repeat: repeat-x;
    font-weight: bold;
  }

  div .theme_breadcrumbs {
    padding-left: 10px;
  }

  .title {
    height: 36px;
    margin-bottom: 12px;
    padding-top: 8px;
    background-image: url(#{$path-image}h1.jpg);
    background-repeat: no-repeat;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    text-indent: 18px;
  }

  .title2 {
    height: 36px;
    margin-bottom: 10px;
    padding-top: 9px;
    background-image: url(#{$path-image}h1_2.jpg);
    background-repeat: no-repeat;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    text-indent: 18px;
  }

  .title3 {
    height: 36px;
    margin-bottom: 10px;
    padding-top: 9px;
    background-image: url(#{$path-image}h1_3.jpg);
    background-repeat: no-repeat;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    text-indent: 18px;
  }

  .title4 {
    height: 36px;
    margin-bottom: 10px;
    padding-top: 9px;
    background-image: url(#{$path-image}h1_4.jpg);
    background-repeat: no-repeat;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    text-indent: 18px;
  }

  .title4wide {
    height: 36px;
    margin-bottom: 10px;
    padding-top: 9px;
    background-image: url(#{$path-image}h1_4wide2.png);
    background-repeat: no-repeat;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    text-indent: 18px;
  }

  .title4semiwide {
    height: 36px;
    margin-bottom: 10px;
    padding-top: 9px;
    background-image: url(#{$path-image}h1_4semiwide2.png);
    background-repeat: no-repeat;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    text-indent: 18px;
  }

  .title4New {
    height: 36px;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 9px;
    background-image: url(#{$path-image}h1_4.jpg);
    background-repeat: no-repeat;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    text-indent: 18px;
  }

  .title_h2 {
    margin: 0;
    font-size: 1em;
    font-weight: normal;
  }

  .style20 {
    color: #9b9b9b;
  }

  .style21 {
    color: #fff;
  }

  .style4 {
    padding-left: 3px;
    font-size: smaller;
  }

  .style28 {
    color: #696969;
    font-size: smaller;
  }

  .style30 {
    font-size: 0.9em;
  }

  .styletopicscap {
    margin-top: 2px;
    padding-left: 3px;
    font-size: 70%;
  }

  a:link {
    color: #062c7d;
    text-decoration: none;
  }

  a:visited {
    color: #062c7d;
    text-decoration: none;
  }

  a:hover {
    color: #00f;
    text-decoration: none;
  }

  a:active {
    color: #00f;
    text-decoration: none;
  }

  #maincont {
    width: 970px;
    margin-right: auto;
    margin-left: auto;
  }

  #leftcolumn {
    width: 215px;
    padding-top: 0;
    padding-right: 7px;
    padding-bottom: 10px;
    padding-left: 0;
  }

  #rightcolumn {
    width: 300px;
    padding-top: 0;
    padding-right: 0;
    padding-bottom: 10px;
    vertical-align: top;
  }

  #centercolumn {
    padding-top: 0;
    padding-right: 7px;
    padding-bottom: 10px;
    padding-left: 0;
    line-height: 150%;
  }

  td.sq {
    padding: 5px;
    line-height: 160%;
    vertical-align: center;
  }

  .search_td {
    padding: 1px 5px;
  }

  .leftTitleText {
    color: #fff;
    font-size: 14px;
  }

  table {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  table td {
    margin: 0;
    padding: 0;
    vertical-align: top;
  }

  h1 {
    font-size: 125%;
  }

  h2 {
    font-size: 112%;
  }

  h3,
  h4,
  h5 {
    font-size: 100%;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 0;
    padding-left: 16px;
    background: url(#{$path-image}"info-button.gif") no-repeat 5px 50%;
    line-height: 18px;
  }

  a.imgtitle {
    font-size: 90%;
    line-height: 140%;
    text-decoration: none;
  }

  a.imgtitle:link {
    color: #6d2f41;
  }

  a.imgtitle:visited {
    color: #6d2f41;
  }

  a.imgtitle:active {
    color: #6d2f41;
  }

  a.imgtitle2 {
    color: #6d2f41;
    font-size: 120%;
    line-height: 150%;
  }

  a.main:link {
    color: #1c4baf;
    text-decoration: none;
  }

  a.main:visited {
    color: #1c4baf;
    text-decoration: none;
  }

  a.main:hover {
    color: #219fe7;
    text-decoration: none;
  }

  a.main1:link {
    color: #5618b4;
    text-decoration: none;
  }

  a.main1:visited {
    color: #5618b4;
    text-decoration: none;
  }

  a.main1:hover {
    color: #00f;
    text-decoration: none;
  }

  a.main2:link {
    color: #062c7d;
    text-decoration: none;
  }

  a.main2:visited {
    color: #062c7d;
    text-decoration: none;
  }

  a.main2:hover {
    color: #00f;
    text-decoration: none;
  }

  a.main3:link {
    color: #9b9b9b;
    text-decoration: none;
  }

  a.main3:visited {
    color: #9b9b9b;
    text-decoration: none;
  }

  a.main3:hover {
    color: #00f;
    text-decoration: none;
  }

  a.main4:link {
    color: #fff;
    text-decoration: none;
  }

  a.main4:visited {
    color: #fff;
    text-decoration: none;
  }

  a.main4:hover {
    color: #00f;
    text-decoration: none;
  }

  input.formButton {
  }

  .item {
    padding-bottom: 10px;
    padding-left: 5px;
  }

  .itemHead {
    padding-left: 5px;
    border-bottom: 3px solid #999;
    color: #666;
    font-weight: bold;
  }

  .itemInfo {
    padding: 3px;
    text-align: left;
  }

  .itemTitle {
    color: #999;
    font-size: 120%;
    font-weight: bold;
  }

  .itemPoster {
    font-size: 90%;
    font-style: italic;
  }

  .itemPostDate {
    margin: 0;
    padding: 0;
    color: #b4ab8d;
    font-size: 85%;
    font-weight: bold;
  }

  .itemStats {
    font-size: 90%;
    font-style: italic;
  }

  .itemBody {
    padding-left: 15px;
  }

  .itemText {
    margin: 0;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 0;
    line-height: 150%;
  }

  /* .itemText:first-letter {font-size: 133%; font-weight: bold;} */
  .itemFoot {
    padding: 3px;
    text-align: right;
  }

  .itemAdminLink {
    font-size: 90%;
  }

  .itemPermaLink {
    font-size: 90%;
  }

  .clear {
    clear: both;
  }

  .space {
    height: 10px;
  }

  #headerlogo {
    height: 97px;
    background-image: url(#{$path-image}"im-hedder2.jpg");
  }

  #headerlogoNew {
    height: 97px;
    background-image: url(#{$path-image}"im-hedder_new.png");
    background-repeat: no-repeat;
  }

  #shadow-blue {
    background-image: url(#{$path-image}"backblue.png");
    background-repeat: repeat-x;
  }

  #shadow-l {
    background-image: url(#{$path-image}"shadow-l.jpgNG");
  }

  #shadow-r {
    background-image: url(#{$path-image}"shadow-r.jpgNG");
  }

  #im-spacer {
    background-image: url(#{$path-image}"im-spacer.jpg");
  }

  .headertext {
    padding-top: 2px;
    padding-bottom: 1px;
    color: #666;
  }

  #headerright {
    position: relative;
    margin-top: 52px;
    margin-bottom: -52px;
    margin-left: -732px;
  }

  #headermenu {
    position: absolute;
    top: -80px;
    left: 730px;
    float: left;
  }

  .headermenulink {
    margin: 0;
    padding: 0;
    padding-right: 5px;
  }

  .headermenulinkimg {
    padding-top: 3px;
    padding-right: 5px;
    padding-left: 5px;
    vertical-align: middle;
  }

  #headerlogin {
    margin-top: 10px;
    margin-right: 5px;
    text-align: right;
  }

  #headerbar {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: #ccc;
  }

  #gnavi {
    padding-left: 5px;
    float: left;
  }

  .main-navi a {
    display: block;
    width: 110px;
    height: 18px;
    padding-top: 12px;
    float: left;
    background-image: url(#{$path-image}"gnav1.jpg");
    background-repeat: no-repeat;
    background-position: 3px 50%;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
  }

  .main-navi a:hover {
    background-image: url(#{$path-image}"gnav2.jpg");
    background-repeat: no-repeat;
    color: #fff;
  }

  #googlesearch {
    width: 250px;
    padding-top: 3px;
    padding-right: 5px;
    float: right;
    text-align: right;
  }

  th {
    padding: 4px;
    color: #fff;
    vertical-align: middle;
  }

  .column2 {
    width: 9px;
    background-image: url(#{$path-image}"menub_01.jpg");
    background-repeat: repeat-y;
    background-position: left 50%;
  }

  #leftcolumn .blockTitle {
    height: 15px;
    padding-top: 11px;
    padding-bottom: 4px;
    background-image: url(#{$path-image}"leftmenu-title_01.jpg");
    background-position: left top;
    color: #fff;
    font-size: 1.1em;
    font-weight: bold;
    text-align: center;
  }

  #leftcolumn .blockTitleleft {
    width: 6px;
    background-image: url(#{$path-image}"leftmenu-title_02.jpg");
    background-position: right top;
  }

  #leftcolumn .blockContent {
    padding: 3px;
    border-top: 1px #ccc;
    background-image: url(#{$path-image}"leftmenu-title_03.jpg");
  }

  #leftcolumn .blockContentleft {
    width: 6px;
    border-top: 1px dotted #ccc;
    background-image: url(#{$path-image}"leftmenu-title_04.jpg");
    background-position: right top;
  }

  .blockBottom {
    height: 15px;
    background-image: url(#{$path-image}"leftmenu-title_05.jpg");
    background-repeat: no-repeat;
  }

  .blockBottomleft {
    width: 6px;
    background-image: url(#{$path-image}"leftmenu-title_06.jpg");
    background-repeat: no-repeat;
    background-position: right top;
  }

  .cont-title {
    height: 23px;
    padding-top: 6px;
    padding-left: 18px;
    background-image: url(#{$path-image}"center-title.jpg");
    background-repeat: no-repeat;
    color: #777;
    font-weight: bold;
  }

  .centerCcolumn {
    padding-bottom: 3px;
    clear: both;
  }

  #centercolumn .blockTitle {
    padding-top: 11px;
    padding-bottom: 4px;
    padding-left: 10px;
    background-image: url(#{$path-image}"centermenu-title_01.jpg");
    background-repeat: repeat-x;
    color: #7b7b7b;
    font-size: 1.1em;
    font-weight: bold;
    text-align: left;
  }

  #centercolumn .blockTitle2 {
    padding-top: 11px;
    padding-bottom: 4px;
    padding-left: 10px;
    background-image: url(#{$path-image}"centermenu-title_01_2.jpg");
    background-position: left top;
    color: #7b7b7b;
    font-size: 1.1em;
    font-weight: bold;
    text-align: left;
  }

  #centercolumn .blockTitle3 {
    padding-top: 11px;
    padding-bottom: 4px;
    padding-left: 10px;
    background-image: url(#{$path-image}"centermenu-title_01_3.jpg");
    background-position: left top;
    color: #7b7b7b;
    font-size: 1.1em;
    font-weight: bold;
    text-align: left;
  }

  #centercolumn .blockTitleleft3 {
    width: 6px;
    background-image: url(#{$path-image}"centermenu-title_02_3.jpg");
    background-position: right top;
  }

  #centercolumn .blockTitleleft {
    width: 6px;
    background-image: url(#{$path-image}"centermenu-title_02.jpg");
    background-position: right top;
  }

  #centercolumn .blockContent {
    padding: 0;
    border-top: 0 dotted #ccc;
    background-image: url(#{$path-image}"centermenu-title_03.jpg");
  }

  #centercolumn .blockContentleft {
    width: 6px;
    border-top: 0 #ccc;
    background-image: url(#{$path-image}"centermenu-title_04.jpg");
    background-position: right top;
  }

  #centercolumn .blockBottom {
    height: 15px;
    background-image: url(#{$path-image}"centermenu-title_05.jpg");
    background-repeat: no-repeat;
  }

  #centercolumn .blockBottomleft {
    width: 6px;
    background-image: url(#{$path-image}"centermenu-title_06.jpg");
    background-repeat: no-repeat;
    background-position: right top;
  }

  .centerCcolumn div.blockTitle {
    clear: both;
    background-image: url(#{$path-image}"center-title_01.jpg");
    background-repeat: no-repeat;
    background-position: left top;
    color: #777;
    font-weight: bold;
  }

  #centercolumn .blockTitleleft2 {
    width: 6px;
    background-image: url(#{$path-image}"centermenu-title_02_2.jpg");
    background-position: right top;
  }

  .centerCcolumn div.blockContent {
    margin-bottom: 10px;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .centerLcolumn {
    width: 48%;
    padding-right: 3px;
    float: left;
    overflow: hidden;
  }

  .centerLcolumn div.blockTitle {
    background-image: url(#{$path-image}"centerl-title_01.jpg");
    background-repeat: no-repeat;
    background-position: left top;
    color: #777;
    font-weight: bold;
  }

  .centerLcolumn div.blockContent {
    margin-bottom: 10px;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .centerRcolumn {
    width: 49%;
    padding-left: 3px;
    float: right;
    overflow: hidden;
  }

  .centerRcolumn div.blockTitle {
    background-image: url(#{$path-image}"centerr-title_01.jpg");
    background-repeat: no-repeat;
    background-position: left top;
    color: #777;
    font-weight: bold;
  }

  .centerRcolumn div.blockContent {
    margin-bottom: 10px;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  div#content {
    text-align: left;
  }

  #rightcolumn .blockTitle {
    padding-top: 12px;
    padding-bottom: 4px;
    padding-left: 10px;
    background-image: url(#{$path-image}"rightmenu-title_01.jpg");
    background-position: left top;
    color: #7b7b7b;
    font-size: 1em;
    font-weight: bold;
    text-align: left;
  }

  #rightcolumn .blockTitle2 {
    padding-top: 11px;
    padding-bottom: 4px;
    padding-left: 10px;
    background-image: url(#{$path-image}"centermenu-title_01.jpg");
    background-position: left top;
    color: #7b7b7b;
    font-size: 1.1em;
    font-weight: bold;
    text-align: left;
  }

  #rightcolumn .blockTitle3 {
    padding-top: 11px;
    padding-bottom: 4px;
    padding-left: 10px;
    background-image: url(#{$path-image}"centermenu-title_01_3.jpg");
    background-position: left top;
    color: #034f89;
    font-size: 1.1em;
    font-weight: bold;
    text-align: left;
  }

  #rightcolumn .blockTitleleft {
    width: 6px;
    background-image: url(#{$path-image}"rightmenu-title_02.jpg");
    background-position: right top;
  }

  #rightcolumn .blockTitleleft2 {
    width: 6px;
    background-image: url(#{$path-image}"centermenu-title_02.jpg");
    background-position: right top;
  }

  #rightcolumn .blockTitleleft3 {
    width: 6px;
    background-image: url(#{$path-image}"centermenu-title_02_3.jpg");
    background-position: right top;
  }

  #rightcolumn .blockContent {
    padding: 3px;
    background-image: url(#{$path-image}"rightmenu-title_03.jpg");
  }

  #rightcolumn .blockContent2 {
    padding: 3px;
    background-image: url(#{$path-image}"centermenu-title_03.jpg");
  }

  #rightcolumn .blockContent3 {
    padding-left: 3px;
    background-image: url(#{$path-image}"centermenu-title_03.jpg");
  }

  #rightcolumn .blockContentleft {
    width: 6px;
    border-top: 1px #ccc;
    background-image: url(#{$path-image}"rightmenu-title_04.jpg");
    background-position: right top;
  }

  #rightcolumn .blockContentleft2 {
    width: 6px;
    border-top: 1px #ccc;
    background-image: url(#{$path-image}"centermenu-title_04.jpg");
    background-position: right top;
  }

  #rightcolumn .blockContentleft3 {
    width: 6px;
    border-top: 1px #ccc;
    background-image: url(#{$path-image}"rightmenu-title_04b.jpg");
    background-position: right top;
  }

  #rightcolumn .blockBottom {
    height: 15px;
    background-image: url(#{$path-image}"rightmenu-title_05.jpg");
    background-repeat: no-repeat;
  }

  #rightcolumn .blockBottom2 {
    height: 15px;
    background-image: url(#{$path-image}"centermenu-title_05.jpg");
    background-repeat: no-repeat;
  }

  #rightcolumn .blockBottom3 {
    height: 15px;
    background-image: url(#{$path-image}"rightmenu-title_05b.jpg");
    background-repeat: no-repeat;
  }

  #rightcolumn .blockBottomleft {
    width: 6px;
    background-image: url(#{$path-image}"rightmenu-title_06.jpg");
    background-repeat: no-repeat;
    background-position: right top;
  }

  #rightcolumn .blockBottomleft2 {
    width: 6px;
    background-image: url(#{$path-image}"centermenu-title_06.jpg");
    background-repeat: no-repeat;
    background-position: right top;
  }

  #rightcolumn .blockBottomleft3 {
    width: 6px;
    background-image: url(#{$path-image}"rightmenu-title_06b.jpg");
    background-repeat: no-repeat;
    background-position: right top;
  }

  .maintitle {
    margin: 0;
    padding-left: 21px;
    background: url(#{$path-image}"title_dot01.gif") no-repeat 5px 50%;
    font-size: 14px;
  }

  .maintitle2 {
    margin: 0;
    padding-left: 21px;
    background: url(#{$path-image}"title_dot02.gif") no-repeat 5px 50%;
    font-size: 14px;
  }

  .titlelist {
    padding-top: 0;
    padding-left: 19px;
    background-color: #e3e5ff;
    background-image: url(#{$path-image}"title-arrow.gif");
    background-repeat: no-repeat;
    background-position-x: left;
    background-position-y: top;
  }

  .subtitle {
    margin: 0;
    padding-left: 20px;
    background: url(#{$path-image}"detail-arrow.gif") no-repeat 5px 50%;
  }

  .titlelist2 {
    padding-top: 0;
    padding-bottom: 4px;
    padding-left: 5px;
  }

  .titlelist3 {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 19px;
    background: #e6e6fd url(#{$path-image}"title-arrow.gif") no-repeat left
      top;
  }

  .titlelist4 {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 5px;
  }

  .titlelist5 {
    padding-top: 0;
    padding-left: 19px;
    background: #eee6f5 url(#{$path-image}"title-arrow2.gif") no-repeat left
      top;
    background-position-x: left;
    background-position-y: top;
  }

  .titlelist6 {
    padding-top: 0;
    padding-bottom: 4px;
    padding-left: 5px;
  }

  .titlelist7 {
    padding-top: 0;
    padding-left: 19px;
    background: #f2f2f2 url(#{$path-image}"title-arrow3.gif") no-repeat left
      top;
    background-position-x: left;
    background-position-y: top;
  }

  #banner {
    margin-top: 20px;
    text-align: center;
  }

  #pagetop {
    padding-top: 1px;
    padding-right: 4px;
    padding-bottom: 1px;
    padding-left: 1px;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #ddd;
    font-size: 10px;
    text-align: right;
    vertical-align: middle;
  }

  .footmenu {
    padding-top: 5px;
    border-top: 1px solid #ccc;
    background-image: url(#{$path-image}"even.gif");
    background-repeat: repeat-x;
    text-align: center;
  }

  .footer {
    padding-top: 3px;
    padding-bottom: 7px;
    background-image: url(#{$path-image}"hbar.jpg");
    background-repeat: repeat-x;
    font-size: 12px;
    text-align: center;
  }

  .footer a:link {
    color: #00f;
  }

  .footer a:visited {
    color: #000080;
  }

  .footer a:active {
    color: #ff8000;
  }

  #mainmenu a {
    display: block;
    margin: 0 3px;
    padding-top: 4px;
    padding-right: 9px;
    padding-bottom: 4px;
    padding-left: 9px;
    border-bottom: 1px solid #eee;
    background-image: url(#{$path-image}"menulink1.gif");
    background-repeat: no-repeat;
  }

  #mainmenu a:hover {
    background-image: url(#{$path-image}"menulink2.gif");
    background-repeat: no-repeat;
  }

  #mainmenu a.menuTop {
    padding-left: 10px;
  }

  #mainmenu a.menuMain {
    padding-left: 10px;
  }

  #mainmenu a.menuSub {
    display: block;
    margin-left: 15px;
    padding-left: 10px;
  }

  #usermenu a {
    display: block;
    margin: 0 3px;
    padding-top: 4px;
    padding-right: 9px;
    padding-bottom: 4px;
    padding-left: 9px;
    border-bottom: 1px solid #eee;
    background-image: url(#{$path-image}"menulink1.gif");
    background-repeat: no-repeat;
  }

  #usermenu a:hover {
    background-image: url(#{$path-image}"menulink2.gif");
    background-repeat: no-repeat;
  }

  #usermenu a.menuTop {
  }

  #usermenu a.highlight {
    background-color: #fcc;
  }

  .outer {
    border: none;
  }

  .head {
    padding: 5px;
    background-color: #ebebeb;
  }

  .even {
    padding-left: 3px;
    background-color: #f0f0f0;
  }

  .odd {
    padding-left: 3px;
    background-color: #fff;
  }

  .even2 {
    padding-left: 3px;
    background-color: #e3e5ff;
  }

  .odd2 {
    padding-left: 3px;
    background-color: #fff;
  }

  .eventop {
    padding-left: 3px;
    padding-left: 19px;
    background: #f0f0f0 url(#{$path-image}"title-arrow3.gif") no-repeat left
      top;
    background-position-x: left;
    background-position-y: top;
  }

  .oddtop {
    padding-left: 3px;
    padding-left: 19px;
    background: #fff url(#{$path-image}"title-arrow3.gif") no-repeat left top;
    background-position-x: left;
    background-position-y: top;
  }

  .foot {
    padding: 5px;
    background-color: #ebebeb;
  }

  .impollfoot {
    background-color: #e0eefb;
    font-size: 85%;
    text-align: left;
  }

  .impollfootLink {
    background-color: #e0eefb;
    font-size: 80%;
    text-align: center;
  }

  div.impollfootLink a {
    color: #1667ff;
    text-decoration: none;
  }

  div.impollfootLink a:hover {
    color: #00f;
    text-decoration: none;
  }

  div.impollfootLink a:visited {
    color: #5618b4;
    text-decoration: none;
  }

  tr.even td {
    background-repeat: repeat-x;
  }

  tr.odd td {
    background-repeat: repeat-x;
  }

  div.errorMsg {
    margin: 10px 0;
    padding: 15px 10px 15px 70px;
    border: 1px solid;
    background-color: #ffbaba;
    background-image: url("/modules/pengin/public/images/error.png");
    background-repeat: no-repeat;
    background-position: 10px center;
    color: #d8000c;
    font-weight: bold;
  }

  div.errorMsg div {
    padding-top: 3px;
    padding-left: 0;
  }

  div.confirmMsg {
    padding: 10px;
    border-top: 1px solid #ddf;
    border-right: 1px solid #aaa;
    border-bottom: 1px solid #aaa;
    border-left: 1px solid #ddf;
    background-color: #ddffdf;
    color: #136c99;
    font-weight: bold;
    text-align: center;
  }

  div.resultMsg {
    padding: 10px;
    border-top: 1px solid silver;
    border-right: 1px solid #666;
    border-bottom: 1px solid #666;
    border-left: 1px solid silver;
    background-color: #ccc;
    color: #333;
    font-weight: bold;
    text-align: center;
  }

  div.xoopsCode {
    width: 400px;
    padding: 0 6px 6px 6px;
    overflow: auto;
    border: 1px inset #000080;
    background: #fff;
  }

  div.xoopsQuote {
    width: 400px;
    padding: 2px;
    overflow: auto;
    border: 1px inset #000080;
    background: #fff;
  }

  div.waku {
    margin-top: 2px;
    margin-bottom: 5px;
    overflow: auto;
    border: 1px inset #000080;
    background: #fff;
  }

  .comTitle {
    margin-bottom: 2px;
    font-weight: bold;
  }

  .comText {
    padding: 2px;
  }

  .comUserStat {
    margin: 2px;
    padding: 2px;
    border: 1px solid silver;
    background-color: #fff;
    color: #2f5376;
    font-size: 10px;
    font-weight: bold;
  }

  .comUserStatCaption {
    font-weight: normal;
  }

  .comUserStatus {
    margin-top: 10px;
    margin-left: 2px;
    color: #2f5376;
    font-size: 10px;
    font-weight: bold;
  }

  .comUserRank {
    margin: 2px;
  }

  .comUserRankText {
    font-size: 10px;
    font-weight: bold;
  }

  .comUserRankImg {
    border: 0 none;
  }

  .comUserName {
  }

  .comUserImg {
    margin: 2px;
  }

  .comDate {
    font-size: smaller;
    font-style: italic;
    font-weight: normal;
  }

  .comDateCaption {
    font-style: normal;
    font-weight: bold;
  }

  .caption {
    color: #963;
  }

  .footer {
    width: 135px;
    background-color: #8d8d8d;
  }

  .num_p {
    color: #d22048;
    font-size: 1em;
    font-weight: bold;
  }

  .f-date {
    color: #369;
    font-size: 1.2em;
    font-weight: bold;
    text-align: right;
  }

  .style24 {
    font-size: smaller;
  }

  /* for eguide module */
  .error {
    color: #f00;
    font-weight: bold;
    text-align: left;
  }

  .evhead {
    color: #800000;
    font-size: 120%;
    font-weight: bold;
    text-align: left;
  }

  .evmark {
    float: right;
    color: #000;
  }

  .evinfo {
    font-size: 75%;
    text-align: left;
  }

  .evprop {
    padding-left: 2em;
    color: #004060;
    font-size: 90%;
    font-weight: bold;
    text-align: left;
  }

  .evbody {
    text-align: left;
  }

  .evlink {
    font-size: 90%;
    text-align: right;
  }

  .evline {
    font-size: 90%;
    text-align: left;
  }

  .evnote {
    color: #c00000;
    font-size: 110%;
    font-weight: bold;
    text-align: center;
  }

  .evtitle {
    padding-bottom: 0.5em;
    color: #000080;
    font-size: 110%;
    font-weight: bold;
    text-align: left;
  }

  .evtbl th {
    text-align: left;
    vertical-align: top;
  }

  .event,
  .evform,
  .evlist,
  .entform {
  }

  .event td {
    margin: 0;
    padding: 5px;
  }

  .event td.evform {
    padding: 5px;
    background-color: #fee;
  }

  .evms th {
    text-align: left;
  }

  .evop td {
    padding: 5px;
    background-color: #fcf;
  }

  .catbox {
    float: right;
  }

  .evform th em,
  .evform em,
  .entform th em,
  .entform em {
    color: #c00;
    font-weight: bold;
  }

  .entform {
    background-color: #eef;
  }

  h2 {
    color: #800000;
  }

  h3 {
    margin-bottom: 0;
    color: #002040;
  }

  #itemhelper,
  #itemhelper input,
  #itemhelper button,
  #itemhelper select {
    font-size: 90%;
  }

  .arealist li {
    color: #c00;
    line-height: 170%;
  }

  tr.h:hover {
    background: #f0f0f0;
  }

  .search-txt {
    color: #999;
    font-size: x-small;
  }

  #keywords1 {
    margin-left: 10px;
    border: 1px solid #ccc;
  }

  #searchBtn1 {
    position: static;
    margin-left: 0;
  }

  /* --�V�����i�r-- */

  div .globalNaviNew {
    width: 100%;
    height: 32px;
    margin: 0 0 15px 0;
    padding: 0;
    overflow: hidden;
    text-align: center;
  }

  li.globalNaviNew a {
    display: block;
    padding-top: 32px;
    overflow: hidden;
    text-align: center;
  }

  /* --topGlobal-- */
  li.globalNaviNew a.topGlobal {
    background: url(#{$path-image}btn01.png) no-repeat;
    color: #f0f0f0;
  }

  li.globalNaviNew a.topGlobal:hover {
    background: url(#{$path-image}btn01-ro.png) no-repeat;
    color: #f0f0f0;
  }

  .topGlobalRo {
    background: url(#{$path-image}btn01-ro.png) no-repeat;
    color: #f0f0f0;
  }

  /* --museumGlobal-- */
  li.globalNaviNew a.museumGlobal {
    background: url(#{$path-image}btn02.png) no-repeat;
    color: #f0f0f0;
  }

  li.globalNaviNew a.museumGlobal:hover {
    background: url(#{$path-image}btn02-ro.png) no-repeat;
    color: #f0f0f0;
  }

  .museumGlobalRo {
    background: url(#{$path-image}btn02-ro.png) no-repeat;
    color: #f0f0f0;
  }

  /* --eventGlobal-- */
  li.globalNaviNew a.eventGlobal {
    background: url(#{$path-image}btn03.png) no-repeat;
    color: #f0f0f0;
  }

  li.globalNaviNew a.eventGlobal:hover {
    background: url(#{$path-image}btn03-ro.png) no-repeat;
    color: #f0f0f0;
  }

  .eventGlobalRo {
    background: url(#{$path-image}btn03-ro.png) no-repeat;
    color: #f0f0f0;
  }

  /* --topicsGlobal-- */
  li.globalNaviNew a.topicsGlobal {
    background: url(#{$path-image}btn04.png) no-repeat;
    color: #f0f0f0;
  }

  li.globalNaviNew a.topicsGlobal:hover {
    background: url(#{$path-image}btn04-ro.png) no-repeat;
    color: #f0f0f0;
  }

  .topicsGlobalRo {
    background: url(#{$path-image}btn04-ro.png) no-repeat;
    color: #f0f0f0;
  }

  /* --newsGlobal-- */
  li.globalNaviNew a.newsGlobal {
    background: url(#{$path-image}btn05.png) no-repeat;
    color: #f0f0f0;
  }

  li.globalNaviNew a.newsGlobal:hover {
    background: url(#{$path-image}btn05-ro.png) no-repeat;
    color: #f0f0f0;
  }

  .newsGlobalRo {
    background: url(#{$path-image}btn05-ro.png) no-repeat;
    color: #f0f0f0;
  }

  /* --newsGlobal-- */
  li.globalNaviNew a.imbbsGlobal {
    background: url(#{$path-image}btn06.png) no-repeat;
    color: #f0f0f0;
  }

  li.globalNaviNew a.imbbsGlobal:hover {
    background: url(#{$path-image}btn06-ro.png) no-repeat;
    color: #f0f0f0;
  }

  .imbbsGlobalRo {
    background: url(#{$path-image}btn06-ro.png) no-repeat;
    color: #f0f0f0;
  }

  /* --eguideGlobal-- */
  li.globalNaviNew a.eguideGlobal {
    background: url(#{$path-image}btn07.png) no-repeat;
    color: #f0f0f0;
  }

  li.globalNaviNew a.eguideGlobal:hover {
    background: url(#{$path-image}btn07-ro.png) no-repeat;
    color: #f0f0f0;
  }

  .eguideGlobalRo {
    background: url(#{$path-image}btn07-ro.png) no-repeat;
    color: #f0f0f0;
  }

  ul.globalNaviNew {
    padding-top: 2px;
    background-color: #fff;
  }

  ul.globalNaviNew li {
    width: 137px;
    padding-right: 2px;
    float: left;
    background: none;
    text-align: center;
  }

  .globalNaviNewButtom {
    height: 3px;
    background-color: #c2c2c1;
  }

  /* --�V�����i�r-- */

  /* --����ɐV�����i�r(�{�^��8��)-- */

  div .NglobalNaviNew {
    width: 100%;
    height: 32px;
    margin: 0 0 15px 0;
    padding: 0;
    overflow: hidden;
    text-align: center;
  }

  li.NglobalNaviNew a {
    display: block;
    padding-top: 32px;
    overflow: hidden;
    text-align: center;
  }

  /* --topGlobal-- */
  li.NglobalNaviNew a.topGlobal {
    background: url(#{$path-image}NNb1.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.topGlobal:hover {
    background: url(#{$path-image}NNb1on.png) no-repeat;
    color: #f0f0f0;
  }

  .topGlobalRo {
    background: url(#{$path-image}NNb1on.png) no-repeat;
    color: #f0f0f0;
  }

  /* --museumGlobal-- */
  li.NglobalNaviNew a.museumGlobal {
    background: url(#{$path-image}NNb2.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.museumGlobal:hover {
    background: url(#{$path-image}NNb2on.png) no-repeat;
    color: #f0f0f0;
  }

  .museumGlobalRo {
    background: url(#{$path-image}NNb2on.png) no-repeat;
    color: #f0f0f0;
  }

  /* --eventGlobal-- */
  li.NglobalNaviNew a.eventGlobal {
    background: url(#{$path-image}NNb3.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.eventGlobal:hover {
    background: url(#{$path-image}NNb3on.png) no-repeat;
    color: #f0f0f0;
  }

  .eventGlobalRo {
    background: url(#{$path-image}NNb3on.png) no-repeat;
    color: #f0f0f0;
  }

  /* --jyunkaiGlobal-- */
  li.NglobalNaviNew a.jyunkaiGlobal {
    background: url(#{$path-image}NNb4.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.jyunkaiGlobal:hover {
    background: url(#{$path-image}NNb4on.png) no-repeat;
    color: #f0f0f0;
  }

  .jyunkaiGlobalRo {
    background: url(#{$path-image}NNb4on.png) no-repeat;
    color: #f0f0f0;
  }

  /* --topicsGlobal-- */
  li.NglobalNaviNew a.topicsGlobal {
    background: url(#{$path-image}NNb5.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.topicsGlobal:hover {
    background: url(#{$path-image}NNb5on.png) no-repeat;
    color: #f0f0f0;
  }

  .topicsGlobalRo {
    background: url(#{$path-image}NNb5on.png) no-repeat;
    color: #f0f0f0;
  }

  /* --newsGlobal-- */
  li.NglobalNaviNew a.newsGlobal {
    background: url(#{$path-image}NNb6.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.newsGlobal:hover {
    background: url(#{$path-image}NNb6on.png) no-repeat;
    color: #f0f0f0;
  }

  .newsGlobalRo {
    background: url(#{$path-image}NNb6on.png) no-repeat;
    color: #f0f0f0;
  }

  /* --newsGlobal-- */
  li.NglobalNaviNew a.imbbsGlobal {
    background: url(#{$path-image}NNb7.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.imbbsGlobal:hover {
    background: url(#{$path-image}NNb7on.png) no-repeat;
    color: #f0f0f0;
  }

  .imbbsGlobalRo {
    background: url(#{$path-image}NNb7on.png) no-repeat;
    color: #f0f0f0;
  }

  /* --eguideGlobal-- */
  li.NglobalNaviNew a.eguideGlobal {
    background: url(#{$path-image}NNb8.png) no-repeat;
    color: #f0f0f0;
  }

  li.NglobalNaviNew a.eguideGlobal:hover {
    background: url(#{$path-image}NNb8on.png) no-repeat;
    color: #f0f0f0;
  }

  .eguideGlobalRo {
    background: url(#{$path-image}NNb8on.png) no-repeat;
    color: #f0f0f0;
  }

  ul.NglobalNaviNew {
    padding-top: 2px;
    background-color: #fff;
  }

  ul.NglobalNaviNew li {
    width: 132px;
    padding-right: 2px;
    float: left;
    background: none;
    text-align: center;
  }

  .NglobalNaviNewButtom {
    height: 3px;
    background-color: #c2c2c1;
  }

  /* --�V�����i�r(�{�^��8��)-- */

  .p1-001 {
    border: 1px solid #ccc;
    background-color: #f7f7f7;
    font-size: 12px;
  }

  .table-css {
    line-height: 150%;
  }

  .link-btn {
    width: 302px;
    height: 110px;
    padding-top: 134px;
    padding-left: 280px;
    background-image: url(/modules/im/img/link-bg.jpg);
    background-repeat: no-repeat;
  }

  .table2-css {
    padding-top: 10px;
    padding-right: 10px;
    padding-bottom: 30px;
    padding-left: 10px;
    border: 1px solid #da5350;
    background-color: #fff9f9;
    line-height: 150%;
  }

  .sub-con {
    width: 563px;
    padding-left: 7px;
    border: 4px solid #f3cdcd;
    background-color: #fff;
  }

  .table3-css {
    padding-top: 10px;
    padding-right: 10px;
    padding-bottom: 30px;
    padding-left: 10px;
    border: 1px solid #2c559f;
    background-color: #f9fcff;
    line-height: 150%;
  }

  .sub-con2 {
    width: 563px;
    padding-left: 7px;
    border: 4px solid #d7e3f8;
    background-color: #fff;
  }

  .table4-css {
    padding-top: 10px;
    padding-right: 10px;
    padding-bottom: 30px;
    padding-left: 10px;
    border: 1px solid #1c611c;
    background-color: #fafffa;
    line-height: 150%;
  }

  .cap {
    color: #930;
    font-size: 10px;
    line-height: 12px;
  }

  .table-imdb {
    font-size: small;
    line-height: 1em;
  }

  .p1-002 {
    margin-left: 120px;
    padding-left: 5px;
    border: 1px solid #ccc;
    background-color: #f7f7f7;
    font-size: 12px;
  }

  .social {
    width: 550px;
    margin-bottom: 15px;
    margin-left: 15px;
    padding-left: 5px;
    border: 1px dashed #ccc;
    background-color: #f7f7f7;
    font-size: 12px;
    text-align: right;
  }

  .block {
    margin: 5px 0;
  }

  .block div {
    margin-right: 5px;
    float: left;
  }

  .clearfix::after {
    content: ".";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
  }

  .clearfix {
    min-height: 1px;
  }

  .clear {
    clear: both;
  }

  .middlebunner {
    width: 402px;
    margin: 0;
    padding: 0;
    background-image: url(/images/back.gif);
  }

  a.photoZoom:hover {
    cursor: url(/images/zoomin.cur), pointer;
  }

  #tab {
    width: 580px;
    height: 35px;
    padding: 0 10px;
    background: url(http://202.239.156.50/modules/im_db/images/bg-menu.png)
      repeat-x;
    color: white;
    line-height: 35px;
  }

  #tabSearch {
    width: 126px;
    margin-left: 360px;
    background: url(http://202.239.156.50/images/btn_imSearch.gif) no-repeat
      center center;
    color: white;
  }

  #tabSearch_close {
    width: 126px;
    background: url(http://202.239.156.50/images/btn_imSearch_close.gif)
      no-repeat center center;
    color: white;
  }

  #tab ul {
    margin: 0;
    list-style-type: none;
  }

  #tabSearch ul {
    margin: 0;
    list-style-type: none;
  }

  #tab li {
    margin: 0;
    padding: 7px;
    float: left;
    list-style-type: none;
    background: none;
    cursor: pointer;
  }

  #tabSearch li {
    width: 126px;
    padding: 0;
    list-style-type: none;
    background: none;
    cursor: pointer;
  }

  #tab li a {
    display: block;
    color: #fff;
  }

  #tabSearch li a {
    display: block;
    color: #000;
  }

  #tab li.select {
    margin: 0;
    background: url(http://202.239.156.50/modules/im_db/images/bg-menu-hover.png)
      no-repeat center center;
  }

  #tabSearch li.select {
    margin: 0;
    background: url(http://202.239.156.50/images/btn_imSearch_close.gif)
      no-repeat center center;
  }

  #tabSearch:hover {
    background: url(http://202.239.156.50/images/btn_imSearch_on.gif)
      no-repeat center center;
  }

  #tabSearch li.select:hover {
    background: url(http://202.239.156.50/images/btn_imSearch_close_on.gif)
      no-repeat center center;
  }

  .disnon {
    display: none;
  }

  .content_wrap {
    width: 590px;
    padding-top: 5px;
    padding-left: 10px;
    clear: left;
    text-align: left;
  }

  .content_wrapSearch {
    width: 510px;
    padding-top: 5px;
    padding-left: 10px;
    clear: left;
    background-color: #cfcfcf;
    text-align: left;
  }

  .content_wraplong {
    width: 638px;
    padding-top: 5px;
    padding-left: 10px;
    clear: left;
    text-align: left;
  }

  .tabLinkactive {
    font-weight: bold;
  }

  ul.tabs {
    width: 100%;
    height: 32px; /* --Set height of tabs-- */
    margin: 0;
    padding: 0;
    float: left;
    border-bottom: 1px solid #999;
    border-left: 1px solid #999;
    list-style: none;
  }

  ul.tabs li {
    position: relative;
    height: 31px; /* --Subtract 1px from the height of the unordered list-- */
    margin: 0;
    margin-bottom: -1px; /* --Pull the list item down 1px-- */
    padding: 0;
    float: left;
    overflow: hidden;
    border: 1px solid #999;
    border-left: none;
    background: #e0e0e0;
    line-height: 31px; /* --Vertically aligns the text within the tab-- */
  }

  ul.tabs li a {
    display: block;
    padding: 0 20px;
    border: 1px solid #fff; /* --Gives the bevel look with a 1px white border inside the list item-- */
    outline: none;
    color: #000;
    font-size: 1.2em;
    text-decoration: none;
  }

  ul.tabs li a:hover {
    background: #ccc;
  }

  html ul.tabs li.active,
  html ul.tabs li.active a:hover {
    border-bottom: 1px solid #fff; /* --Makes the active tab look like it's connected with its content-- */

    /* --Makes sure that the active tab does not listen to the hover properties-- */
    background: #fff;
  }

  .tab_container {
    width: 100%;
    float: left;
    clear: both;
    overflow: hidden;
    border: 1px solid #999;
    border-top: none;
    background: #fff;
  }

  .tab_content {
    padding: 20px;
    font-size: 1.2em;
  }

  #txtAddress {
    width: 100px;
    height: 25px;
    padding: 5px 5px 5px 26px;
    border: 1px solid #ccc;
    background: url(/images/search.png) no-repeat 8px 12px;
  }

  #im_search_btn_img {
    top: 27px;
  }

  #im_search_btn_img {
    left: -130px;
  }

  .copy {
    clear: both;
    font-size: 77%;
    text-align: right;
  }

  .gazou_cell {
    border: 1px solid #999;
    background-color: #fff;
    text-align: center;
    vertical-align: middle;
  }

  a.photoZoom:hover {
    cursor: url(/images/zoomin.cur), pointer;
  }

  .inp-form {
    padding: 3px;
    border: 1px solid #acacac;
  }

  selector {
    word-wrap: break-word; /* IE 5+ */
    white-space: pre; /* CSS 2.0 */
    white-space: pre-wrap; /* CSS 2.1 */
    white-space: pre-line; /* CSS 3.0 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: -moz-pre-wrap; /* Mozilla */
    white-space: -hp-pre-wrap; /* HP Printers */
  }

  .pagenavi {
    padding: 0;
    font-weight: bold;
  }

  .pagenavi ul {
    margin: 0;
    padding: 0;
    font-size: 14px;
    text-align: right;
  }

  .pagenavi li {
    display: inline;
    margin: 0 2px;
    padding: 0;
    padding-bottom: 1px;
    list-style-type: none;
  }

  .pagenavi a {
    padding: 0 5px;
    border: 1px solid #9aafe5;
    background: #dfedf7;
    color: #000;
    text-decoration: none;
  }

  .pagenavi a:hover {
    border: 1px solid #2b66a5;
    background: #eef7fc;
    color: #000;
  }

  .pagenavi strong {
    padding: 0 5px;
    border: 1px solid navy;
    background: #2e6ab1;
    color: #fff;
  }

  .pagenavi li.prepage,
  .pagenav li.nextpage {
    padding: 0 5px;
    font-weight: bold;
  }

  .pagenavi .strongnavi {
    padding: 0 5px;
    border: 1px solid navy;
    background: #2e6ab1;
    color: #fff;
  }

  .pagenav {
    padding: 0;
    font-weight: bold;
  }

  .pagenav ul {
    margin: 0;
    padding: 0;
    font-size: 14px;
    text-align: right;
  }

  .pagenav li {
    display: inline;
    margin: 0 2px;
    padding: 0;
    padding-bottom: 1px;
    list-style-type: none;
    background-image: none;
  }

  .pagenav a {
    padding: 0 5px;
    border: 1px solid #9aafe5;
    background: #dfedf7;
    color: #000;
    text-decoration: none;
  }

  .pagenav a:hover {
    border: 1px solid #2b66a5;
    background: #eef7fc;
    color: #000;
  }

  .pagenav li.currentpage {
    padding: 0 5px;
    border: 1px solid navy;
    background: #2e6ab1;
    color: #fff;
  }

  .pagenav li.prepage,
  .pagenav li.nextpage {
    padding: 0 5px;
    font-weight: bold;
  }

  ul.info,
  ul.success,
  ul.warning,
  ul.error {
    margin: 10px 0;
    padding: 15px 10px 15px 70px;
    border: 1px solid;
    background-repeat: no-repeat;
    background-position: 10px center;
  }

  ul.info li,
  ul.success li,
  ul.warning li,
  ul.error li {
    list-style: disc;
  }

  ul.info {
    background-color: #bde5f8;
    background-image: url("/modules/pengin/public/images/info.png");
    color: #00529b;
  }

  ul.info li {
    background-image: none;
    color: #00529b;
  }

  ul.success {
    background-color: #dff2bf;
    background-image: url("/modules/pengin/public/images/success.png");
    color: #4f8a10;
  }

  ul.success li {
    background-image: none;
    color: #4f8a10;
  }

  ul.warning {
    background-color: #feefb3;
    background-image: url("/modules/pengin/public/images/warning.png");
    color: #9f6000;
  }

  ul.warning li {
    background-image: none;
    color: #9f6000;
  }

  ul.error {
    background-color: #ffbaba;
    background-image: url("/modules/pengin/public/images/error.png");
    color: #d8000c;
  }

  ul.error li {
    background-image: none;
    color: #d8000c;
  }

  #kensakubasyo {
    margin-top: -82px;
  }

  /* Safari 3�ȏ�AChrome�̂� */
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    #kensakubasyo {
      margin-top: -80px;
    }
  }

  img {
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  a:hover img {
    opacity: 0.5;
    filter: alpha(opacity=50); /* Ie� */
  }

  .sp-change-link {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .sp-change-link a {
    display: block;
    position: relative;
    width: 98%;
    margin: 30px auto 0;
    border: 3px solid #afafaf;
    border-radius: 10px;
    background: linear-gradient(to bottom, #fff 49%, #ebebeb 100%);
    color: #333;
    font-size: 48px;
    font-weight: bold;
    line-height: 94px;
    text-align: center;
    text-decoration: none;
  }

  .sp-change-link a::after {
    content: ">";
    position: absolute;
    right: 30px;
  }

  @media screen and (max-device-width: 420px) {
    #rakutenLimitedId_header {
      margin-top: 170px;
    }

    .sp-change-link {
      display: block;
    }
  }

  div.pico_breadcrumbs {
    padding: 0 0 3px;
    border-bottom: 1px #aaa solid;
    font-size: 95%;
  }

  .pico_body {
    margin: 0 -2px;
    padding: 15px 8px;
  }

  div.pico_menu h1 {
    margin: 18px 0 0 0;
    padding: 3px;
    background-color: #eee;
  }

  div.pico_menu h2 {
    margin: 18px 0 0 10px;
    padding: 3px;
    background-color: #eee;
  }

  div.pico_menu h3 {
    margin: 18px 0 0 20px;
    padding: 3px;
    background-color: #eee;
  }

  div.pico_menu h4 {
    margin: 18px 0 0 30px;
    padding: 3px;
    background-color: #eee;
  }

  div.pico_menu h5 {
    margin: 18px 0 0 40px;
    padding: 3px;
    background-color: #eee;
  }

  div.pico_menu div.level1 {
    margin-left: 0;
  }

  div.pico_menu div.level2 {
    margin-left: 10px;
  }

  div.pico_menu div.level3 {
    margin-left: 20px;
  }

  div.pico_menu div.level4 {
    margin-left: 30px;
  }

  div.pico_menu div.level5 {
    margin-left: 40px;
  }

  em.pico_notice {
    color: #f00;
    font-style: normal;
    font-weight: bold;
  }

  div.pico_controllers_in_menu {
    position: relative;
    top: -1.5em;
    float: right;
  }

  div.bottom_of_content_body {
    clear: right;
  }

  ul.pico_list_contents li {
    list-style: none outside;
  }

  ul.pico_list_contents_in_menu li {
    list-style: none outside;
  }

  div.pico_print_icon {
    width: 40px;
    height: 40px;
    float: right;
  }

  div.pico_tellafriend_icon {
    width: 40px;
    height: 40px;
    float: right;
  }

  div.pico_vote form {
    display: inline;
  }

  table.pico_pagenavigation {
    margin-top: 20px;
    border-top: 1px #aaa solid;
  }

  table.pico_form_table th.pico_waiting {
    color: red;
  }

  table.pico_form_table td.pico_waiting {
    background-color: white;
    color: red;
  }

  table.pico_form_table td,
  table.pico_form_table th {
    color: black;
    text-align: left;
    vertical-align: top !important;
  }

  p.pico_submit {
    margin: 0;
    padding: 10px;
    text-align: center;
  }

  input.pico_ascii_only {
    ime-mode: disabled;
  }

  input.pico_number_only {
    text-align: right;
    ime-mode: disabled;
  }

  pre.pico_history_diff del {
    color: red;
  }

  pre.pico_history_diff ins {
    color: blue;
  }

  div.pico_pagebreak {
    margin: 10px;
  }

  div.pico_pagebreak span {
    margin: 2px;
    padding: 2px;
    border: 1px solid black;
  }

  div.pico_pagebreak span.selected {
    border: 0;
  }

  p {
    padding-right: 15px;
    padding-left: 10px;
  }

  p > br {
    clear: both;
  }

  table[style*="background-color: #c8c8c8"] {
    display: none;
  }
}

.c-gSearch {
  width: 620px;

  &_title {
    font-size: 14px;
    text-align: center;
  }

  &_form {
    padding: 10px;
    display: flex;
    justify-content: center;
    margin-bottom: 32px;
    background-color: #ccc;
    -webkit-animation-name: fdinup;
    animation-name: fdInUp;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
  }

  &_input {
    width: 380px;
  }

  &_btn {
    &_confirmButton {
      width: 140px;
      height: 48px;
      background-color: #231815;
      font-size: 16px;
      text-align: center;
      color: #fff;

      &_icon {
        display: inline-block;
        width: 20px;
        height: 21px;
        margin-right: 5px;
        background-image: url(@/assets/images/icon-search.png);
        background-repeat: no-repeat;
        background-size: contain;
        vertical-align: middle;
      }

      &[disabled] {
        background-color: #444;
        cursor: default;
      }
    }
  }
}
</style>
